export default `/* Ids Pager Button Component */
:host(ids-pager-button) {
  display: inline-flex;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtcGFnZXIiLCJzb3VyY2VzIjpbImlkcy1wYWdlci1idXR0b24uc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtBQUNBO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyIvKiBJZHMgUGFnZXIgQnV0dG9uIENvbXBvbmVudCAqL1xuOmhvc3QoaWRzLXBhZ2VyLWJ1dHRvbikge1xuICBkaXNwbGF5OiBpbmxpbmUtZmxleDtcbn1cbiJdfQ== */`;
